var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "super_nav_config",
      attrs: {
        disabled: _vm.disabled,
        model: _vm.value.config,
        "label-position": "left",
        "hide-required-asterisk": "",
      },
    },
    [
      _c("div", { staticClass: "label" }, [
        _vm._v(" 是否开启副标题 "),
        _c("span", { staticClass: "tips" }, [
          _vm._v(
            " （开启副标题功能，每个分类都要填，保证前台显示整齐好看。） "
          ),
        ]),
      ]),
      _c(
        "el-form-item",
        {
          attrs: {
            rules: [
              {
                required: true,
                trigger: "change",
              },
            ],
            prop: "is_open_sub_name",
          },
        },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.is_open_sub_name,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "is_open_sub_name", $$v)
                },
                expression: "value.config.is_open_sub_name",
              },
            },
            [
              _c("el-radio", { attrs: { label: "0" } }, [_vm._v("关闭")]),
              _c("el-radio", { attrs: { label: "1" } }, [_vm._v("开启")]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "label" }, [
        _vm._v(" 设置分类及排序 "),
        _c("span", { staticClass: "tips" }, [_vm._v("（拖动分类可调整排序）")]),
      ]),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "box" },
            [
              _c("div", { staticClass: "header" }, [
                _c("div", [_vm._v("分类" + _vm._s(index + 1))]),
                _vm.value.config.value.length > 1
                  ? _c(
                      "div",
                      {
                        staticClass: "handle",
                        on: {
                          click: function ($event) {
                            return _vm.onDelete(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-delete" }),
                        _vm._v(" 删除 "),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "header margin_none" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".name",
                        rules: [
                          {
                            required: true,
                            message: "名称不可为空",
                          },
                          {
                            min: 1,
                            max: 6,
                            message: "名称长度为1-6",
                          },
                        ],
                        label: "展示为",
                        "label-width": "50px",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "可输入1-6字", clearable: "" },
                        model: {
                          value: item.name,
                          callback: function ($$v) {
                            _vm.$set(item, "name", $$v)
                          },
                          expression: "item.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "color_picker",
                      attrs: {
                        prop: "value." + index + ".name_color",
                        rules: [
                          {
                            required: true,
                            message: "名称颜色不可为空",
                          },
                        ],
                        label: "颜色",
                        "label-width": "40px",
                      },
                    },
                    [
                      _c("el-color-picker", {
                        model: {
                          value: item.name_color,
                          callback: function ($$v) {
                            _vm.$set(item, "name_color", $$v)
                          },
                          expression: "item.name_color",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.value.config.is_open_sub_name === "1"
                ? _c(
                    "div",
                    { staticClass: "header margin_none" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "value." + index + ".sub_name",
                            rules: [
                              {
                                required: true,
                                message: "副标题不可为空",
                              },
                              {
                                min: 1,
                                max: 6,
                                message: "副标题长度为1-6",
                              },
                            ],
                            label: "副标题",
                            "label-width": "50px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "可输入1-6字",
                              clearable: "",
                            },
                            model: {
                              value: item.sub_name,
                              callback: function ($$v) {
                                _vm.$set(item, "sub_name", $$v)
                              },
                              expression: "item.sub_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "color_picker",
                          attrs: {
                            prop: "value." + index + ".sub_name_color",
                            rules: [
                              {
                                required: true,
                                message: "副标题颜色不可为空",
                              },
                            ],
                            label: "颜色",
                            "label-width": "40px",
                          },
                        },
                        [
                          _c("el-color-picker", {
                            model: {
                              value: item.sub_name_color,
                              callback: function ($$v) {
                                _vm.$set(item, "sub_name_color", $$v)
                              },
                              expression: "item.sub_name_color",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "value." + index + ".id",
                    rules: [
                      {
                        required: true,
                        message: "菜单不可为空",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.menuListFilter,
                      "collapse-tags": "",
                      props: {
                        label: "show_name",
                        value: "id",
                        children: "childrens",
                        checkStrictly: true,
                        emitPath: true,
                      },
                      filterable: "",
                      clearable: "",
                      placeholder: "请选择菜单",
                    },
                    on: {
                      change: function (val) {
                        return _vm.changeMenu(val, item, index)
                      },
                    },
                    model: {
                      value: item.id,
                      callback: function ($$v) {
                        _vm.$set(item, "id", $$v)
                      },
                      expression: "item.id",
                    },
                  }),
                ],
                1
              ),
              Array.isArray(item.id) && item.id.length > 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选择产品列表配置" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openConfig(index)
                            },
                          },
                        },
                        [_vm._v("配置产品列表")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "el-form-item",
        {
          staticClass: "label",
          attrs: {
            prop: "selected_color",
            label: "选中后的主题色",
            rules: [
              {
                required: true,
                message: "主题色不可为空",
              },
            ],
          },
        },
        [
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.selected_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "selected_color", $$v)
              },
              expression: "value.config.selected_color",
            },
          }),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "el-icon-plus add_btn",
          attrs: { type: "primary" },
          on: { click: _vm.addBox },
        },
        [_vm._v(" 添加分类")]
      ),
      _c("div", { staticClass: "label" }, [
        _vm._v(" 与上方组件的间距 "),
        _c("span", { staticClass: "tips" }, [
          _vm._v(" （当前组件与上一组件的距离，可填入正负整数） "),
        ]),
      ]),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "label" }, [
        _vm._v(" 层级高度值 "),
        _c("span", { staticClass: "tips" }, [
          _vm._v(
            " （模块间如遇重叠，层级数值越小展现级别越高、可填入正整数） "
          ),
        ]),
      ]),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.showDrawer,
            title: _vm.configData.name + "配置",
            size: "450px",
            "custom-class": "myDrawer",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDrawer = $event
            },
          },
        },
        [
          _c(_vm.configData.key + "_config", {
            ref: "commonConfig",
            tag: "component",
            staticClass: "commonConfig",
            attrs: {
              parentKey: "super_nav",
              disabled: _vm.disabled,
              tabListFlat: _vm.tabListFlat,
              menuList: _vm.menuList,
              info: _vm.info,
              childrenMenuList: _vm.childrenMenuList,
              customerModuleList: _vm.customerModuleList,
              eBookCategoryList: _vm.eBookCategoryList,
              aBookCategoryList: _vm.aBookCategoryList,
              customerPackageList: _vm.customerPackageList,
              systemMenus: _vm.systemMenus,
              uploadInfo: _vm.uploadInfo,
            },
            model: {
              value: _vm.configData,
              callback: function ($$v) {
                _vm.configData = $$v
              },
              expression: "configData",
            },
          }),
          !_vm.disabled
            ? _c(
                "div",
                { staticClass: "configBtns" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveConfig },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }